export default __webpack_public_path__ + "static/media/security.84073060.jpg";